import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   width: 400px;
   display: flex;
   flex-direction: column;
   gap: 1rem;

   .section {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
   }

   .label {
      font-size: 0.875rem;
      font-weight: 600;
      color: #333;
      margin-bottom: 0.25rem;
   }

   .status-container {
      background: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 1rem;
   }

   .qr-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
   }

   .qr-code {
      background: white;
      padding: 1rem;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
         max-width: 200px;
         max-height: 200px;
         display: block;
      }
   }

   .status-text {
      font-size: 0.875rem;
      color: #666;
      text-align: center;

      &.error {
         color: #ef4444;
      }
   }

   .status-connected {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      justify-content: center;
   }

   .status-icon {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: #10b981;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.25rem;
      font-weight: bold;
   }

   .phone-number {
      font-size: 0.75rem;
      color: #999;
      margin-top: 0.25rem;
   }

   .helper-text {
      font-size: 0.75rem;
      color: #666;
      line-height: 1.5;
      text-align: center;
      max-width: 300px;
   }

   .variables-info {
      background: #f9f9f9;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 1rem;
   }

   .variable-list {
      margin-top: 0.75rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
   }

   .variable-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.5rem;
      background: #fff;
      border-radius: 4px;
      font-size: 0.75rem;

      .variable-name {
         color: #333;
         font-weight: 500;
      }

      code {
         background: #e0e7ff;
         padding: 0.25rem 0.5rem;
         border-radius: 4px;
         font-family: 'Courier New', monospace;
         color: #3730a3;
         font-size: 0.7rem;
      }
   }

   .info-box {
      background: #f0f9ff;
      border: 1px solid #bfdbfe;
      border-radius: 8px;
      padding: 1rem;

      p {
         margin: 0;
         font-size: 0.75rem;
         color: #666;
         line-height: 1.5;

         & + p {
            margin-top: 0.5rem;
         }
      }
   }

   .copy-button {
      background: #3b82f6;
      color: white;
      border: none;
      padding: 0.5rem 1rem;
      border-radius: 4px;
      cursor: pointer;
      font-size: 0.75rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      transition: all 0.2s;

      &:hover {
         background: #2563eb;
      }

      &.copied {
         background: #10b981;
      }
   }
`;